import React from "react";
import { ModelHeadingSection } from "../../modelHeadingSection";
import { Status } from "src/types";

interface UnknownArrivalHeadingSectionProps {
  warehouseCheckInId: string;
  status?: Status;
}

const UnknownArrivalHeadingSection: React.FC<UnknownArrivalHeadingSectionProps> = ({ warehouseCheckInId, status }) => (
  <ModelHeadingSection identifierHeader={`Unknown Arrival Issue | ${warehouseCheckInId}`} status={status} />
);

export { UnknownArrivalHeadingSection };
